import MailboxInfo from 'owa-client-ids/lib/schema/MailboxInfo';
import { calendarEvent } from 'mini-calendar-event-converter';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getCalendarViewService } from 'mini-calendar-event-services/lib/services/getCalendarViewService';
import { getEarlierDate, getLaterDate } from 'mini-datetime-utils/lib/dateTimeUtils';
import { OwaDate } from 'owa-datetime';
import { throwResponseError } from 'mini-calendar-event-services/lib/utils/throwResponseError';
import { trace } from 'owa-trace';

/**
 * Based on the mailboxINfo, returns the default getter for calendar
 * @param mailboxInfo
 */
export const defaultGetCalendarEventsCallback = (mailboxInfo: MailboxInfo) => async (
    startDate: OwaDate,
    endDate: OwaDate
): Promise<CalendarEvent[]> => {
    let items = [];
    try {
        const response = await getCalendarViewService(startDate, endDate);
        if (response?.ResponseClass === 'Success') {
            items = response.Items.reduce(
                ({ events, addedIds }, calendarItem) => {
                    const id = calendarItem?.ItemId?.Id;
                    if (id && !addedIds.has(id)) {
                        const event = calendarEvent(calendarItem, mailboxInfo);
                        event.Start = getLaterDate(event.Start, startDate);
                        event.End = getEarlierDate(event.End, endDate);
                        addedIds.add(id);
                        events.push(event);
                    }
                    return { events, addedIds };
                },
                { events: new Array<CalendarEvent>(), addedIds: new Set<string>() }
            ).events;
        } else {
            throwResponseError(response);
        }
    } catch (error) {
        trace.warn(error);
        items = [];
    }

    return items;
};
